<template>
  <div class="mall-header">
    <div class="title" @click="goPath('/mall')">联创商城</div>
    <router-link
      v-for="(el, index) in routes"
      :exact="index === 0"
      :key="index"
      :to="el.path"
      active-class="active"
      custom
      tag="div"
    >
      <div class="menu">{{ el.name }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "mallHeader",
  data() {
    return {
      routes: [
        {
          name: "解决方案",
          path: "/solution",
          key: "solution",
        },
        {
          name: "服务市场",
          path: "/service",
          key: "service",
        },
        {
          name: "IoT硬件",
          path: "/replace",
          key: "replace",
        },
        // {
        //   name: "工业应用",
        //   path: "/market",
        //   key: "market",
        // },
        {
          name: "供应商库",
          path: "/treasury",
          key: "treasury",
        },
        {
          name: "元服务",
          path: "/metaService",
          key: "metaService",
        },
      ],
    };
  },
  methods: {
    goPath(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="scss">
.mall-header {
  width: 100%;
  height: 64px;
  background: #ffffff;
  padding: 24px;
  display: flex;
  align-items: center;
  border-top: 1px solid #e2e8f0;
  > :not(:last-child) {
    margin-right: 40px;
  }
  > .title {
    font-weight: 600;
    font-size: 18px;
    color: #262626;
    line-height: 25px;
    cursor: pointer;
  }
  .menu {
    cursor: pointer;
    &:hover {
      color: #ea0b06;
    }
  }
  .active {
    color: #ea0b06;
  }
}
</style>
